<template>
  <div id="contenedor-main-listado-actividades">
    <template v-if="!tipoLista">
      <desktop :listadoActividades="listadoActividades" :soloLectura="soloLectura"></desktop>
    </template>
    <template v-else>
      <lista :listadoActividades="listadoActividades"></lista>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Lista from './Listado.vue';

export default {
  name: 'MainListadoActividades',
  props: {
    listadoActividades: {
      type: Array,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: true,
    },
    tipoLista: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Desktop,
    Lista,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
